import xray, { PixRadSDKVersion } from 'app/native/node-addons/xray';
import electron from 'app/native/node/electron';
import getPath from 'app/native/node/path';
import fs from 'app/native/node/fs';
import _ from 'lodash';
import { FlatPanelConfigurationState } from 'app/redux/flatPanelConfiguration/reducer';

const getDetectorManager = () => xray()?.DetectorManager.get();

// eslint-disable-next-line camelcase
const migratePixrad9_5_0_SerialNumberChange = (pixradUserConfigPath: string) => {
  try {
    const path = getPath();
    const referencesPath = path.join(pixradUserConfigPath, 'references');
    const referencesFiles = fs().readdirSync(referencesPath);

    const oldAPIReferencesFiles = _.filter(referencesFiles, (filename) =>
      filename.startsWith('SN')
    );

    oldAPIReferencesFiles.forEach((filename) => {
      const newFilename = filename.replace('SN', '');
      if (fs().existsSync(path.join(referencesPath, newFilename))) return;
      fs().copyFileSync(
        path.join(referencesPath, filename),
        path.join(referencesPath, newFilename)
      );
    });
  } catch {
    //
  }
};

const initDetectorManager = (config: FlatPanelConfigurationState) => {
  if (!xray()) return undefined;

  if (getDetectorManager()) return getDetectorManager();

  const path = getPath();
  const { remote } = electron();

  // const XRayPackagePath = path.dirname(window.require.resolve('xray/package.json'));
  // @ts-ignore
  const baseConfigPath = path.join(window.electronRootDir, 'base_configurations');
  const userConfigPath = path.join(remote.app.getPath('userData'), 'xray_configurations');

  const pixradv9BasePath = path.join(
    // @ts-ignore
    window.electronRootDir,
    'pixrad9_bin'
  );
  const pixradv10BasePath = path.join(
    // @ts-ignore
    window.electronRootDir,
    'pixrad10_bin'
  );

  // Path is not pixrad9_configurations because it was the old pixrad configuration folder before v10 introduction
  const pixrad9UserConfigsPath = path.join(remote.app.getPath('userData'), 'pixrad_configurations');

  const pixrad10UserConfigsPath = path.join(
    remote.app.getPath('userData'),
    'pixrad10_configurations'
  );

  try {
    migratePixrad9_5_0_SerialNumberChange(pixrad9UserConfigsPath);
  } catch {
    //
  }

  const detectorManager = xray().DetectorManager.create({
    GER: [baseConfigPath, userConfigPath],
    THALES: [
      PixRadSDKVersion.V9,
      path.join(pixradv9BasePath, 'pixrad.dll'),
      path.join(pixradv9BasePath, 'pixrad_configurations'),
      pixrad9UserConfigsPath,
      'config/config_3543EZhd',
    ],
    THALES_3543EZX: [
      PixRadSDKVersion.V10,
      path.join(pixradv10BasePath, 'pixrad.dll'),
      path.join(pixradv10BasePath, 'pixrad_configurations'),
      pixrad10UserConfigsPath,
      'config/config_3543EZX',
    ],
    config,
  });
  return detectorManager;
};

export { initDetectorManager, getDetectorManager };
